import React from "react";
import {
  FaMicrophone,
  FaPenFancy,
  FaExpand,
  FaBroadcastTower,
  FaFileAlt,
  FaLanguage,
} from "react-icons/fa";

export default function Features() {
  const features = [
    { icon: <FaMicrophone />, title: "Speech to Text", text: "Unlimited Docs, Different Voices, Accents and Dialects" },
    { icon: <FaPenFancy />, title: "AI Correction", text: "Auto corrects grammar, spellings & punctuation" },
    { icon: <FaExpand />, title: "AI Expansion", text: "Auto Enhance and simplify the complex text with intelligent explanations" },
    { icon: <FaBroadcastTower />, title: "AI Tone Refiner", text: "Auto transform and fine-tune your text and enhance its language effortlessly" },
    { icon: <FaFileAlt />, title: "AI DOC Reframer", text: "Revamp your document with enhanced clarity and rephrased excellence" },
    { icon: <FaLanguage />, title: "Translation", text: "Fast and accurate translations in many languages" },
    { icon: <FaLanguage />, title: "Transcription", text: "Seamlessly transcribe and translate text across languages." },
    { icon: <FaFileAlt />, title: "Image to Text", text: "Instantly convert images to editable text with a single click" },
    { icon: <FaExpand />, title: "Draft Hub", text: "Legal Drafting & Pleadings Templates" },
  ];

  return (
    <>
      <style>{`
        /* Container (no change to hero) */
        .features-section { margin-top: 60px; padding-bottom: 60px; background: #fff; }
        .features-container { width: min(1180px, 94%); margin: 0 auto; }

        /*
          GRID:
          - horizontal gap = 0 (cards touch)
          - vertical gap = 30px
        */
        .features-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px 0; /* row-gap column-gap => 30px vertical, 0 horizontal */
        }

        /*
          CARD styling:
          - no border (so edges look flush)
          - subtle vertical-focused shadow (minimizes visible side seam)
          - no transform on hover (prevents movement)
        */
        .feature-card {
          position: relative;
          overflow: hidden;
          background: #fff;
          padding: 34px 28px;
          border: none;
          border-radius: 6px;
          min-height: 220px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          cursor: pointer;
          margin: 0;
          /* vertical shadow only: y-offset positive, small blur, negative or zero spread to avoid side glow */
          box-shadow: 0 10px 18px rgba(0,0,0,0.06);
          transition: box-shadow 220ms ease; /* no transform */
        }

        /* stronger shadow on hover but no movement */
        .feature-card:hover {
          box-shadow: 0 16px 30px rgba(0,0,0,0.10);
          transform: none !important;
        }

        /* overlay: slides from top -> down on hover, sits behind content */
        .feature-card::before {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(180deg, #e86f22 0%, #e86f22 100%);
          transform: translateY(-100%);
          transition: transform 360ms cubic-bezier(.22,.9,.32,1);
          z-index: 1;
          pointer-events: none;
        }
        .feature-card:hover::before { transform: translateY(0); }

        /* content above overlay */
        .feature-content { position: relative; z-index: 2; }

        /* icon/title/text */
        .feature-icon {
          width: 60px; height: 60px; border-radius: 10px;
          background: rgba(232,111,34,0.08); color: #e86f22;
          display:flex; align-items:center; justify-content:center;
          font-size:26px; margin-bottom:14px;
          transition: color 200ms ease, background 200ms ease;
        }
        .feature-title { font-size:18px; margin-bottom:8px; font-weight:600; color:#222; transition: color 200ms ease; }
        .feature-text { font-size:15px; color:#555; line-height:1.6; transition: color 200ms ease; }

        /* on hover make icon/title/text white */
        .feature-card:hover .feature-icon { background: rgba(255,255,255,0.12); color:#fff; }
        .feature-card:hover .feature-title,
        .feature-card:hover .feature-text { color: #fff; }

        /* Ensure cards stretch to equal height so rows align perfectly */
        .features-grid > * { align-self: stretch; }

        /* Responsive */
        @media (max-width: 992px) {
          .features-grid { grid-template-columns: repeat(2, 1fr); gap: 24px 0; }
        }
        @media (max-width: 600px) {
          .features-grid { grid-template-columns: 1fr; gap: 20px 0; }
          .feature-card { padding: 28px 20px; min-height: 200px; }
        }

      `}</style>

      <section className="features-section">
        <div className="features-container">
          <div className="features-grid">
            {features.map((f, i) => (
              <div key={i} className="feature-card">
                <div className="feature-content">
                  <div className="feature-icon">{f.icon}</div>
                  <h3 className="feature-title">{f.title}</h3>
                  <p className="feature-text">{f.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
